module.exports = __webpack_public_path__ + "static/media/tree_4.9c0ee886.jpg";